import {
  ADD_BUSINESS,
  ADD_BUSINESS_SUCCESS,
  ADD_BUSINESS_CLEAN,
  ADD_BUSINESS_ERROR,
} from "./actionTypes"

export const addBusiness = form => ({
  type: ADD_BUSINESS,
  payload: { form },
})

export const addBusinessSuccess = business => {
  return {
    type: ADD_BUSINESS_SUCCESS,
    payload: { business },
  }
}

export const addBusinessClean = () => {
  return {
    type: ADD_BUSINESS_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: ADD_BUSINESS_ERROR,
    payload: error,
  }
}
